import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {
  procedureDetails: {
    procedureType: string;
    procedures: {
      procedureId: string;
      procedure: string;
    }[];
  }[];
  error: boolean;
} = {
  procedureDetails: [],
  error: false,
};
const setProcedureDetails = (state = initialState, action) => {
  console.log(action.procedureDetails);
  const updatedState = {
    procedureDetails: action.procedureDetails,
    error: false,
  };
  return updateObject(state, updatedState);
};
const procedureDetails = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PROCEDURE_DETAILS:
      return setProcedureDetails(state, action);
    case actionTypes.FETCH_PROCEDURE_DETAILS_FAILED: {
      return {
        ...state,
        error: true,
      };
    }
    default:
      return state;
  }
};
export default procedureDetails;
